import thunk from 'redux-thunk';
import logger from 'redux-logger';

export const middlewares = [thunk, logger];
